import { Api, ModelRow } from "@mcleod/core";
import {
    BlurEvent,
    Button,
    Checkbox,
    ClickEvent,
    Layout,
    LookupModelSelectionEvent,
    Panel,
    SelectionType,
    SlideoutDecorator,
    TableRow,
    TableRowDisplayEvent,
    TableRowExpansionEvent,
    TableSelectionEvent,
    Image,
    Label,
    ScreenStack,
    DataSource,
    DataSourceExecutionEvent
} from "@mcleod/components";
import { AutogenLayoutMultiSendRateConfirmation } from "./autogen/AutogenLayoutMultiSendRateConfirmation";
import { SendRateConfirmation } from "@mcleod/powerbroker";
import { CommonDialogs } from "@mcleod/common";
import { OrderMultiSelectErrorModal } from "@mcleod/general/src/OrderMultiSelectErrorModal";

export class MultiSendRateConfirmation extends AutogenLayoutMultiSendRateConfirmation {
    errorCount: number = 0;
    sendSelectedButton: Button;
    sourceMultiSendRateCon: DataSource;


    override onLoad(): void {
    }

    public static async showSlideout(selectedRows: TableRow[]) {
        const multiRateConProps = selectedRows.map(row => {
            const modelRow = row.data;
            return {
                ...modelRow.data,
                default_contact: modelRow.get("carrier_contact"),
                default_email_address: modelRow.get("carrier_contact_email"),
                vendor_id: "H"
            };
        });

        const saveButton = new Button({
            id: "buttonSendSelected",
            caption: "Send Selected",
            onClick: async (event: ClickEvent) => {
                layout.buttonSendSelectedOnClick(event);
                selectedRows[0].table.selectedRows = [];
            },
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false
        })

        const layout = Layout.getLayout("lme/dispatch/planning/MultiSendRateConfirmation") as MultiSendRateConfirmation;
        layout.sendSelectedButton = saveButton;
        return new SlideoutDecorator({
            title: "Multi-Select Send Rate Confirmations",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.searchMovementsRateConfirmation(multiRateConProps);
                layout.tableMultiRateCon.addRowCollapseListener((collapseEvent) => {
                    const snackbarTarget = ScreenStack.getSnackbarTarget();
                    snackbarTarget.dismissAllPopups();
                });
            },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            },
            addlComponents: [saveButton]
        });
    }

    buttonSendSelectedOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        if (this.tableMultiRateCon.selectedRows.length === 0) {
            CommonDialogs.showMessage("Please select at least one movement to send.");
            button.busy = false;
            return;
        }
        this.sendRateConRows(this.tableMultiRateCon.selectedRows, button);
    }

    sendRateConRows(selectedMultiRows: TableRow[], button?: Button) {
            const selectedMovements = selectedMultiRows.map(row => row.data as ModelRow);
            Api.search("lme/dispatch/planning/multi-send-rate-con", {movements: selectedMovements, should_send: true}).then((response) => {
                if(button) button.busy = false;
                if (this) {
                    this.tableMultiRateCon.selectedRows = [];
                    this.slideOut();
                }
                const errors = response.data[0]?.errors
                const errorRows = selectedMultiRows.filter(row => errors.some(error => error.order_id === row.data.getString("order_id")));
                errorRows.forEach(row => row.data.set("error", errors.find(error => error.order_id === row.data.getString("order_id")).message));
                OrderMultiSelectErrorModal.showModal(errorRows, [], selectedMultiRows.length - errorRows.length, "Send Rate Con Status", "Retry", (selectedErrorRows) => this.sendRateConRows(selectedErrorRows));
            });
    }



    async searchMovementsRateConfirmation(multiRateConProps: any[]) {
        await this.mainDataSource.search({movements: multiRateConProps, should_send: false});
    }


    tableMultiRateConOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const checkbox = tableRow.findComponentById("checkboxSelectRow") as Checkbox;
        if (modelRow.get("carrier_id", "") == "" || modelRow.get("default_email_address", "") == "" || modelRow.get("default_template", "") == "" ||
            !modelRow.getBoolean("sucessfully_assigned", true) || (modelRow.get("email_verified") && modelRow.get("verification_action") == false) || tableRow.data.get("qualification_status") == "Disqualified") {
            const imageDisqualified = tableRow.findComponentById("imageDisqualified") as Image;
            checkbox.enabled = false;
            tableRow.enabled = false;
            if (imageDisqualified) {
                imageDisqualified.visible = true;
                imageDisqualified.tooltipDynamicContent = async () => {
                    return await this.makeUserQuickInfoLayout(modelRow);
                }
            }
            this.errorCount++;
        }
        else {
            this.tableMultiRateCon.selectRow(tableRow, SelectionType.DISTINCT, null);
        }
        const ediImage = tableRow.findComponentById("dfLabel");
        if (ediImage) {
            ediImage.visible = modelRow.get("is_edi") == true;
        }
        this.updateTitleNumbers();
    }

    private async makeUserQuickInfoLayout(modelRow: ModelRow): Promise<Layout> {
        const layout = await Layout.getLoadedLayout("lme/dispatch/planning/MultiSendRateConQual");
        if (!modelRow.get("default_email_address")) {
            const label = new Label({
                text: "Email Address",
                fontBold: true,
                rowBreak: true
            });
            layout.add(label);
        }
        if (modelRow.get("default_template") == null) {
            const label = new Label({
                text: "Template",
                fontBold: true,
                rowBreak: true
            });
            layout.add(label);
        }
        if (modelRow.get("email_verified") && modelRow.get("verification_action") == false) {
            const label = new Label({
                text: "Highway Verifcation",
                fontBold: true,
                rowBreak: false
            });
            layout.add(label);
        }
        if (modelRow.get("carrier_id", "") == "") {
            const label = new Label({
                text: "Error assigning carrier",
                fontBold: true,
                rowBreak: false
            });
            layout.add(label);
        }
        if (modelRow.get("qualification_status") == "Disqualified") {
            const label = new Label({
                text: "Carrier Qualification",
                fontBold: true,
                rowBreak: true
            });
            layout.add(label);
        }
        return layout;
    }

    tableMultiRateConOnSelect(event: TableSelectionEvent) {
        this.updateTitleNumbers();
    }

    async tableMultiRateConOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const data = tableRow.data;
        const movement_id = data.get("movement_id");
        const email = data.get("default_email_address");
        const comment_text = data.get("comment_text");
        const template_number = data.get("default_template");
        const contact_name = data.get("default_contact");
        const subject = data.get("subject");
        const email_cc = data.get("email_cc");
        const expandComponent = await tableRow.getExpansionComponentLoaded() as Panel;
        const sendRateCon = expandComponent.findComponentById("layoutSendRateConfirmation") as SendRateConfirmation;
        sendRateCon.panelHeader.visible = false;
        sendRateCon.mainDataSource.search({movement_id, email_address: email == "" ? null : email,
            comment_text, template_number, contact_name, subject, email_cc}).then((response) => {
            sendRateCon.validateSimple();
            const deafult_email = response?.modelRows[0].get("default_email_address");
            tableRow.data.set("default_email_address", deafult_email);
            sendRateCon.checkIfReadyToSend(tableRow, sendRateCon, this.makeUserQuickInfoLayout);
            sendRateCon.splitterRateConf.buttonExpandFirst.clicked();
        });
        sendRateCon.textboxEmailAddress.addBlurListener(async (event: BlurEvent) => {
            if (event.changedWhileFocused) {
                tableRow.data.set("default_email_address", sendRateCon.textboxEmailAddress.text);
                this.emailChangeListener(tableRow, sendRateCon);
            }
        });
        sendRateCon.textboxContactName.addLookupModelSelectionListener(async (event: LookupModelSelectionEvent) => {
            tableRow.data.set("default_contact", event.selection?.get("name"));
            if (event.selection?.get("email")) {
                tableRow.data.set("default_email_address", event.selection?.get("email"));
            }
            else {
                tableRow.data.set("default_email_address", "");
                sendRateCon.textboxEmailAddress.text = "";
            }
            this.emailChangeListener(tableRow, sendRateCon);
        });
        sendRateCon.textboxDefaultTemplate.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            tableRow.data.setLookupModelData("default_template", event.selection);
            tableRow.data.set("default_template", event.selection?.get("template_number"));
            const textboxTemplate = tableRow.findComponentById("textboxTemplate");
            if (textboxTemplate) {
                textboxTemplate.displayData(tableRow.data, null, tableRow.index);
            }
            sendRateCon.checkIfReadyToSend(tableRow, sendRateCon, this.makeUserQuickInfoLayout);
        });
        sendRateCon.textboxComment.addBlurListener((event: BlurEvent) => {
            tableRow.data.set("comment_text", sendRateCon.textboxComment.text);
        });
        sendRateCon.textboxSubject.addBlurListener((event: BlurEvent) => {
            tableRow.data.set("subject", sendRateCon.textboxSubject.text);
        });
        sendRateCon.textboxCC.addBlurListener((event: BlurEvent) => {
            tableRow.data.set("email_cc", sendRateCon.textboxCC.text);
        });

        sendRateCon.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            tableRow.data.set("warnings", sendRateCon.mainDataSource.activeRow.get("warnings"));
            tableRow.data.set("errors", sendRateCon.mainDataSource.activeRow.get("errors"));
            tableRow.data.set("qualification_status", sendRateCon.mainDataSource.activeRow.get("qualification_status"));
            tableRow.data.set("qualification_details", sendRateCon.mainDataSource.activeRow.get("qualification_details"));
            sendRateCon.checkIfReadyToSend(tableRow, sendRateCon, this.makeUserQuickInfoLayout);
        });
        this.tableMultiRateCon.setRowsExpanded(false, (row: TableRow) => row.index !== tableRow.index);
    }

    updateTitleNumbers() {
        this.labelTotalCount.text = this.tableMultiRateCon.selectedRows.length.toString();
        this.labelErrorCount.text = this.tableMultiRateCon.rows.filter(row => row.enabled == false).length.toString();
        if (this.tableMultiRateCon.selectedRows.length == 0) {
            this.sendSelectedButton.enabled = false;
            this.sendSelectedButton.disabledTooltip = "You must select at least one movement to send.";
        }
        else {
            this.sendSelectedButton.enabled = true;
        }
    }

    async emailChangeListener(tableRow: TableRow, sendRateCon: SendRateConfirmation) {
        const body = {
            movement_id: this.mainDataSource.activeRow.get("movement_id"),
            order_id: this.mainDataSource.activeRow.get("order_id"),
            email_address: sendRateCon.textboxEmailAddress.text,
            contact_name: this.mainDataSource.activeRow.get("default_contact"),
            vendor_id: "H"
        };
        const response = await Api.post("lme/powerbroker/email-search", body);
        tableRow.data.set("email_verified", response.data[0].email_verified ? true : false);
        tableRow.data.set("verification_action", response.data[0].verification_action ? true : false);
        tableRow.data.set("internal_verification", response.data[0].internal_verification ? true : false);
        sendRateCon.fetchHighwayLoadLockDetails(response.data[0]);
    }
}
